import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrLink from 'client/components/SrLink/SrLink';
import { numberWithCommas } from 'common/formatters';
import { LISTING_DATA_SOURCE_SMART_APARTMENT } from 'common/listingConstants';

class SrPinnedListingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listingId: '',
    };
  }

  static propTypes = {
    disabled: PropTypes.bool,
    listings: PropTypes.array.isRequired,
    onTogglePinnedListing: PropTypes.func.isRequired,
  };

  _onPinListing = (e) => {
    e.preventDefault();
    const { onTogglePinnedListing } = this.props;
    onTogglePinnedListing({
      listingId: this.state.listingId,
      pinned: true,
    });
    this.setState({
      listingId: '',
    });
  };

  _onUnpinListing = (listingId) => {
    const { onTogglePinnedListing } = this.props;
    onTogglePinnedListing({
      listingId: listingId,
      pinned: false,
    });
  };

  _formatPrice = (listing) => {
    if (listing.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT) {
      return `${numberWithCommas(listing.minUnitPrice)}-${numberWithCommas(listing.maxUnitPrice)}`;
    }
    return `${numberWithCommas(listing.price)}`;
  };

  render() {
    const { listingId } = this.state;
    const { listings, disabled } = this.props;

    const LISTING_STATUS_TO_CLASS_NAME_MAPPING = {
      Active: 'status-success',
      'Leased/Rented': 'status-danger',
      sold: 'status-danger',
      'N/A': 'status-warning',
      Pending: 'status-warning',
    };

    return (
      <div>
        <form onSubmit={this._onPinListing}>
          <input
            type="text"
            placeholder="Listing ID"
            value={listingId}
            onChange={(event) => this.setState({ listingId: event.target.value })}
          />
          <button
            type="submit"
            className="button yellow"
            disabled={disabled || !listingId}
            onClick={(e) => this._onPinListing(e)}
          >
            pin listing
          </button>
        </form>
        <div className="pinned-listings-list">
          {listings.map((listing) => (
            <div className="pinned-listings-row" key={`listing-${listing.id}`}>
              <span>
                <div>
                  <SrLink
                    to={`/listing/${listing.id}`}
                    target="_blank"
                    className="pinned-listings-link"
                  >
                    {listing.id}
                  </SrLink>
                  &nbsp;&nbsp;-&nbsp;&nbsp;
                  <span className={`${LISTING_STATUS_TO_CLASS_NAME_MAPPING[listing.status]}`}>
                    {listing.status}
                  </span>
                </div>
                <div>
                  {listing.addressStreetDisplay} - ${this._formatPrice(listing)}
                </div>
              </span>
              <span
                onClick={() => this._onUnpinListing(listing.id)}
                className="delete-listing-span"
              >
                <span role="img" aria-label="delete-listing-icon">
                  🙅‍
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

SrPinnedListingForm.displayName = 'SrPinnedListingForm';

export default SrPinnedListingForm;
